import React from 'react';

export const Info = (props) => (
    <svg {...props} viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.5 25.9C14 26 13.5 26 13 26C12.5 26 12 26 11.5 25.9V22.9V17V16C10.4 16 9.5 15.1 9.5 14H11.5H12.5H14.5V16V22.9V25.9ZM13 0C5.8 0 0 5.8 0 13C0 18.6 3.5 23.4 8.5 25.2V21.9C5.2 20.3 3 16.9 3 13C3 7.5 7.5 3 13 3C18.5 3 23 7.5 23 13C23 16.9 20.8 20.3 17.5 21.9V25.2C22.5 23.4 26 18.6 26 13C26 5.8 20.2 0 13 0ZM13 12C14.1 12 15 11.1 15 10C15 8.9 14.1 8 13 8C11.9 8 11 8.9 11 10C11 11.1 11.9 12 13 12Z" />
    </svg>
);

export default Info;
